import script from "./EditPromotion.vue?vue&type=script&lang=ts&setup=true"
export * from "./EditPromotion.vue?vue&type=script&lang=ts&setup=true"

import "./EditPromotion.vue?vue&type=style&index=0&id=165d3ad8&scoped=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-165d3ad8"]])

export default __exports__